import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { PaymentCardDto } from '../dtos';
import { PaymentCardsFlowType } from '../enums';
import { CanPayResults } from '../enums/can-pay-response.enum';

export enum PaymentCardsActionTypes {
  CheckCanPay = '[PaymentCards] CheckCanPay',
  CheckCanPaySuccess = '[PaymentCards] CheckCanPaySuccess',
  CheckCanPayError = '[PaymentCards] CheckCanPayError',
  LoadPaymentCards = '[PaymentCards] LoadPaymentCards',
  LoadPaymentCardsSuccess = '[PaymentCards] LoadPaymentCardsSuccess',
  LoadPaymentCardsError = '[PaymentCards] LoadPaymentCardsError',
  CheckPaymentCardsStatus = '[PaymentCards] CheckPaymentCardsStatus',
  CheckPaymentCardsStatusSuccess = '[PaymentCards] CheckPaymentCardsStatusSuccess',
  CheckPaymentCardsStatusError = '[PaymentCards] CheckPaymentCardsStatusError',
  SelectPaymentCard = '[PaymentCards] SelectPaymentCard',
  DeletePaymentCard = '[PaymentCards] DeletePaymentCard',
  DeletePaymentCardSuccess = '[PaymentCards] DeletePaymentCardSuccess',
  DeletePaymentCardError = '[PaymentCards] DeletePaymentCardError',
}

export const checkCanPaySuccessAction = createAction(PaymentCardsActionTypes.CheckCanPaySuccess, props<{ flow: PaymentCardsFlowType }>());
export const checkCanPayErrorAction = createAction(
  PaymentCardsActionTypes.CheckCanPayError,
  props<{ canPayStatus: CanPayResults; flow: PaymentCardsFlowType }>()
);
export const loadPaymentCardsAction = createAction(PaymentCardsActionTypes.LoadPaymentCards, props<{ flow: PaymentCardsFlowType }>());
export const loadPaymentCardsSuccessAction = createAction(
  PaymentCardsActionTypes.LoadPaymentCardsSuccess,
  props<{ paymentCards: PaymentCardDto[]; flow: PaymentCardsFlowType }>()
);
export const loadPaymentCardsErrorAction = createAction(
  PaymentCardsActionTypes.LoadPaymentCardsError,
  props<{ failure: AppStateFailure }>()
);

export const selectPaymentCardAction = createAction(PaymentCardsActionTypes.SelectPaymentCard, props<{ paymentCard: PaymentCardDto }>());

export const deletePaymentCardAction = createAction(PaymentCardsActionTypes.DeletePaymentCard, props<{ paymentCardID: number }>());
export const deletePaymentCardSuccessAction = createAction(
  PaymentCardsActionTypes.DeletePaymentCardSuccess
);
export const deletePaymentCardErrorAction = createAction(
  PaymentCardsActionTypes.DeletePaymentCardError,
  props<{ failure: AppStateFailure }>()
);